import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import TextField from '@mui/material/TextField'
import { func, object } from 'prop-types'
import { CvsAutoComplete } from '@components'
import { dates } from '@global/constants'
import {
  isSplitGovernanceTypeForDestination,
  belongsToPattern,
} from 'field-governance/split-actions'
import { SplitText } from 'field-governance/split-text'
import { t } from '@lingui/core/macro'

export const Date = ({ form, setForm, disabled }) => {
  return (
    <>
      <CvsAutoComplete
        name="date-order"
        margin="dense"
        required
        disabled={disabled}
        label={t`Date order`}
        options={Object.keys(dates.order).map(key => ({ label: dates.order[key], value: key }))}
        onSelected={value => setForm(prev => ({ ...prev, date: { ...prev.date, order: value } }))}
        selected={form.date.order || ''}
      />
      <CvsAutoComplete
        name="month-format"
        margin="dense"
        required
        disabled={disabled}
        label={t`Month format`}
        options={Object.keys(dates.formats.MONTH).map(key => ({
          label: dates.formats.MONTH[key],
          value: key,
        }))}
        onSelected={value => setForm(prev => ({ ...prev, date: { ...prev.date, months: value } }))}
        selected={form.date.months || ''}
      />
      <CvsAutoComplete
        name="day-format"
        margin="dense"
        required
        disabled={disabled}
        label={t`Day format`}
        options={Object.keys(dates.formats.DAY).map(key => ({
          label: dates.formats.DAY[key],
          value: key,
        }))}
        onSelected={value => setForm(prev => ({ ...prev, date: { ...prev.date, days: value } }))}
        selected={form.date.days || ''}
      />
      <CvsAutoComplete
        name="year-format"
        margin="dense"
        required
        disabled={disabled}
        label={t`Year format`}
        options={Object.keys(dates.formats.YEAR).map(key => ({
          label: dates.formats.YEAR[key],
          value: key,
        }))}
        onSelected={value => setForm(prev => ({ ...prev, date: { ...prev.date, years: value } }))}
        selected={form.date.years || ''}
      />

      <TextField
        margin="dense"
        variant="outlined"
        disabled={disabled}
        name="separator"
        placeholder='example: "."'
        value={form.delimiter}
        onChange={({ target: { value } }) => setForm(prev => ({ ...prev, delimiter: value }))}
        label={t`Separator`}
      />
      <FormControlLabel
        name="date-auto-populate"
        margin="dense"
        control={
          <Checkbox
            disabled={disabled}
            onChange={({ target: { checked } }) =>
              setForm(prev => ({ ...prev, date: { ...prev.date, auto_populate: checked } }))
            }
            checked={Boolean(form.date.auto_populate)}
          />
        }
        label={t`Auto populate on submission`}
      />
      {isSplitGovernanceTypeForDestination(form.governance_type) && !belongsToPattern(form) ? (
        <SplitText form={form} setForm={setForm} disabled={disabled} />
      ) : null}
    </>
  )
}

Date.propTypes = {
  form: object.isRequired,
  setForm: func.isRequired,
}
